module.exports = __webpack_public_path__ + "static/media/checkedGrey.4ee016e2.svg";